import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TrainingLevel } from './model/training-level.model';
import { ErrorCode } from '../../models/error-code.model';

export const TrainingLevelApiActions = createActionGroup({
    source: 'API/TrainingLevel',
    events: {
        'load training levels': emptyProps()
    }
});

export const TrainingLevelActions = createActionGroup({
    source: 'TrainingLevel',
    events: {
        'load training level success': props<{ trainingLevels: TrainingLevel[] }>(),
        'load training level failure': props<{ error: ErrorCode }>()
    }
});
